import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const StepsList = styled.ol`
  list-style: none;
  list-style-position: inside;
  counter-reset: steps-counter;
  padding-left: 25px;
  font-size: 14px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  line-height: 1.5;
  text-align: left;

  a {
    text-decoration: none;

    &:hover,
    &:active,
    &:focus {
      text-decoration: underline;
    }
  }

  > li {
    position: relative;
    counter-increment: steps-counter;
    padding-left: 12px;
    padding-top: 3px;

    &::before {
      position: absolute;
      top: 2px;
      left: -25px;
      content: counter(steps-counter);
      display: inline-block;
      font-weight: 400;
      width: 24px;
      line-height: 24px;
      font-size: 14px;
      text-align: center;
      color: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.primaryColor
      };
      background: ${withVar(DesignToken.SurfaceModerateDefault)};
      border-radius: 50%;
    }
  }
`;

export const LiWithMargin = styled.li`
  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
`;
